import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import {withStyles} from "@material-ui/core";

class AgeSlider extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            value: [0,100]
        }
    }

    valuetext(value) {
        return `${value}`;
    }

    componentWillMount() {
        if (this.props.sliderVal === []) {
            this.props.handleSliderChange([0,100])
            this.setState({value:[0,100]});
        } else
        this.setState({value:this.props.sliderVal});
    }


    handleChange = (event, newValue) => {
        this.setState({value:newValue});
/*
        this.props.handleSliderChange(newValue)
*/
    };

    render() {
        return (
            <div >
{/*                <Slider
                    // min={0}
                    // max={100}
                    value={this.state.value}
                    // defaultValue={this.props.sliderVal}
                    onChange={this.handleChange}
                    valueLabelDisplay="auto "
                    aria-labelledby="ios slider"
                    getAriaValueText={this.valuetext}
                />*/}
                <FilterSlider valueLabelDisplay="auto" aria-label="Age" defaultValue={100}/>
            </div>
        );
    }

}

const useStyles = makeStyles({
    root: {
        width: 300,
        color: '#005f7f',
    },
});

function valuetext(value) {
    return `${value}`;
}

const FilterSlider = withStyles({
    root: {
        color: '#005f7f',
        height: 8,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        marginTop: -8,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        height: 8,
        borderRadius: 4,
    },
    rail: {
        height: 8,
        borderRadius: 4,
    },
})(Slider);

export default AgeSlider
